import { useState, useEffect } from 'react';
import { FaCog, FaServer, FaDatabase, FaUserShield, FaNetworkWired } from 'react-icons/fa';
import { fetchSystemSettings, updateSystemSettings } from './api';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('general');
  const [settings, setSettings] = useState({
    general: {
      instanceName: '',
      defaultLanguage: 'en',
      purgeInactiveProfiles: 180,
      purgeInactiveEvents: 30
    },
    security: {
      allowedOrigins: '',
      sessionTimeout: 30,
      requireAuthentication: true
    },
    tracking: {
      anonymousProperties: [],
      defaultScope: 'cdp',
      defaultSource: 'web'
    },
    integration: {
      restApiEndpoint: '',
      websocketEndpoint: '',
      kafkaBootstrapServers: ''
    }
  });

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    const data = await fetchSystemSettings();
    setSettings(data);
  };

  const handleSave = async (section) => {
    await updateSystemSettings(section, settings[section]);
    // Show success message
  };

  const renderGeneralSettings = () => (
    <div className="settings-section">
      <h2>General Settings</h2>
      <div className="form-group">
        <label>Instance Name</label>
        <input
          type="text"
          value={settings.general.instanceName}
          onChange={(e) => setSettings({
            ...settings,
            general: { ...settings.general, instanceName: e.target.value }
          })}
        />
      </div>
      <div className="form-group">
        <label>Default Language</label>
        <select
          value={settings.general.defaultLanguage}
          onChange={(e) => setSettings({
            ...settings,
            general: { ...settings.general, defaultLanguage: e.target.value }
          })}
        >
          <option value="en">English</option>
          <option value="fr">French</option>
          <option value="de">German</option>
        </select>
      </div>
      <div className="form-group">
        <label>Purge Inactive Profiles (days)</label>
        <input
          type="number"
          value={settings.general.purgeInactiveProfiles}
          onChange={(e) => setSettings({
            ...settings,
            general: { ...settings.general, purgeInactiveProfiles: parseInt(e.target.value) }
          })}
        />
      </div>
      <button className="save-btn" onClick={() => handleSave('general')}>
        Save General Settings
      </button>
    </div>
  );

  const renderSecuritySettings = () => (
    <div className="settings-section">
      <h2>Security Settings</h2>
      <div className="form-group">
        <label>Allowed Origins (comma-separated)</label>
        <input
          type="text"
          value={settings.security.allowedOrigins}
          onChange={(e) => setSettings({
            ...settings,
            security: { ...settings.security, allowedOrigins: e.target.value }
          })}
        />
      </div>
      <div className="form-group">
        <label>Session Timeout (minutes)</label>
        <input
          type="number"
          value={settings.security.sessionTimeout}
          onChange={(e) => setSettings({
            ...settings,
            security: { ...settings.security, sessionTimeout: parseInt(e.target.value) }
          })}
        />
      </div>
      <div className="form-group checkbox-group">
        <label>
          <input
            type="checkbox"
            checked={settings.security.requireAuthentication}
            onChange={(e) => setSettings({
              ...settings,
              security: { ...settings.security, requireAuthentication: e.target.checked }
            })}
          />
          Require Authentication for API Access
        </label>
      </div>
      <button className="save-btn" onClick={() => handleSave('security')}>
        Save Security Settings
      </button>
    </div>
  );

  return (
    <div className="settings-container">
      <div className="settings-header">
        <h1>System Settings</h1>
      </div>

      <div className="settings-content">
        <div className="settings-sidebar">
          <button
            className={`sidebar-btn ${activeTab === 'general' ? 'active' : ''}`}
            onClick={() => setActiveTab('general')}
          >
            <FaCog /> General
          </button>
          <button
            className={`sidebar-btn ${activeTab === 'security' ? 'active' : ''}`}
            onClick={() => setActiveTab('security')}
          >
            <FaUserShield /> Security
          </button>
          <button
            className={`sidebar-btn ${activeTab === 'tracking' ? 'active' : ''}`}
            onClick={() => setActiveTab('tracking')}
          >
            <FaDatabase /> Tracking
          </button>
          <button
            className={`sidebar-btn ${activeTab === 'integration' ? 'active' : ''}`}
            onClick={() => setActiveTab('integration')}
          >
            <FaNetworkWired /> Integration
          </button>
          <button
            className={`sidebar-btn ${activeTab === 'performance' ? 'active' : ''}`}
            onClick={() => setActiveTab('performance')}
          >
            <FaServer /> Performance
          </button>
        </div>

        <div className="settings-main">
          {activeTab === 'general' && renderGeneralSettings()}
          {activeTab === 'security' && renderSecuritySettings()}
          {/* Add other settings sections */}
        </div>
      </div>
    </div>
  );
};

export default Settings; 